import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import type { LobbySettings } from "@rosette/ts/src/business/game/LobbySettings.js";
import { Path } from "@rosette/ts/src/util/Path.js";
import { startRemoteGame } from "@/app/game/startRemoteGame.js";
import type { GameAPI } from "@rosette/ts/src/business/api/GameAPI.js";
import { KnownLobbySettings } from "@rosette/ts/src/business/game/KnownLobbySettings.js";
import type { APIUser } from "@rosette/ts/src/business/api/api_schema.js";


function encodeBool(value: boolean): string {
    return value ? "y" : "n";
}


export async function startGame(
    router: AppRouterInstance,
    user: APIUser | null,
    settings: LobbySettings,
    gameAPI: GameAPI,
): Promise<void> {
    const lobbyID = settings.getLobbyID();
    if (lobbyID) {
        router.push(`/game/${lobbyID}`);
        return;
    }
    if (settings.isRemote() || !(settings instanceof KnownLobbySettings))
        return await startRemoteGame(router, user, settings, gameAPI);

    const params: Record<string, string> = {
        tab: "play",
        mode: settings.getMode().getID(),
        rules: settings.getRuleset().getID(),
        bot: settings.getBotType().getID(),
    };

    if (!settings.getRuleset().hasSettings()) {
        const gameSettings = settings.getCustomGameSettings();
        params["dice"] = gameSettings.getDice().getID();
        params["path"] = gameSettings.getPaths().getID();
        params["pieces"] = `${gameSettings.getStartingPieceCount()}`;
        params["safe_rosettes"] = encodeBool(gameSettings.areRosettesSafe());
        params["rosettes_reroll"] = encodeBool(gameSettings.doRosettesGrantExtraRolls());
        params["captures_reroll"] = encodeBool(gameSettings.doCapturesGrantExtraRolls());
    }

    router.push(new Path("/game", params).toString());
}
